export enum $tenantDetailsTabs {
  workspaces = 'workspaces',
  academy = 'academy',
}
